export default __webpack_public_path__ + "static/media/rainbowl-logo.3972abdc.png";